<ul class="px-6 py-4 flex flex-col gap-2 overflow-hidden">
  @for (element of menuItems; track index; let index = $index) {
    @let items = visibleItems(element.items);
    @if (items.length) {
      <li class="font-normal py-1 w-full text-gray-300 text-xs">
        @if (!collapseService.collapsed()) {
          {{ element.label | translate }}
        } @else if (index > 0) {
          <div class="bg-gray-medium dark:bg-dark-border h-[1px] w-full"></div>
        }
      </li>
    }
    @for (item of items; track id; let id = $index) {
      <li>
        @if (item.href) {
          <a
            class="flex py-3 h-11 px-4 rounded-lg items-center font-normal text-base text-secondary hover:bg-gray-100 dark:hover:bg-dark-hover hover:text-primary dark:hover:text-gray-200 ease-in-out duration-200"
            [attr.href]="item.href"
            [attr.target]="item.openInNewTab ? '_blank' : null"
            [attr.rel]="item.openInNewTab ? 'noopener noreferrer' : null"
            [tooltip]="item.title | translate"
          >
            <span>
              <lucide-angular size="18" [name]="item.icon"></lucide-angular>
            </span>
            @if (!collapseService.collapsed()) {
              <span class="ml-2">{{ item.title | translate }}</span>
            }
          </a>
        } @else {
          <a
            class="flex py-3 h-11 px-4 rounded-lg items-center font-normal text-base hover:bg-gray-100 dark:hover:bg-dark-hover hover:text-primary dark:hover:text-gray-200 ease-in-out duration-200"
            [class.text-secondary]="!menuLink.isActive"
            [routerLink]="item.route"
            [routerLinkActive]="['bg-gray-100', 'dark:bg-dark-hover', 'text-primary', 'dark:text-dark-text', 'font-semibold']"
            [tooltip]="item.title | translate"
            [state]="{ resetSearchStorage: item.resetSearchStorage }"
            #menuLink=routerLinkActive
          >
            <span [class.text-theme-primary]="menuLink.isActive">
              <lucide-angular size="18" [name]="item.icon"></lucide-angular>
            </span>
            @if (!collapseService.collapsed()) {
              <span class="ml-2">{{ item.title | translate }}</span>
            }
          </a>
        }
      </li>
    }
  }
</ul>
